import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';
import { toDataResult, ToResult } from '@team23/ts-result';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    MultiFilterModel,
} from '@ui/shared/util-filter';
import { SportAtlasService, SportOrderingEnum } from '@ui/shared/util-api';
import type { SportMapFilterKey } from '../../types/sport-map-filter';

@Injectable({ providedIn: 'root' })
export class SportsSelectFilterConfigService extends FilterConfigService<SportMapFilterKey, SportAtlasService> {
    public override type = 'multiselect' as const;

    constructor() {
        super(
            new MultiFilterModel('sports', 'Sportart', []),
            inject(SportAtlasService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return this._api.getAllSports({
            order: [SportOrderingEnum.Name],
        })
            .pipe(
                map(result =>
                    result.data.map(dto => ({
                        value: dto.id,
                        label: dto.name,
                    })),
                ),
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
